// extracted by mini-css-extract-plugin
module.exports = {"tip":"Tip_tip__2uXMF","tip-title":"Tip_tip-title__kFGBM","tip-text":"Tip_tip-text__2DMw3"};